import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import LangContext, { i18n } from "modules/shared/context/langContext";
import { Modal, Form, Input, Button, Checkbox, Select, Row, Col } from "antd";
import { Formik, ErrorMessage } from "formik";
import * as yup from "yup";
import { removeLists } from "../actions";
import { fil } from "date-fns/locale";

const FormItem = Form.Item;

const { Option } = Select;

class FilterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.formik = null;
  }

  componentDidMount() {
    const {
      loadZone,
      loadMaintenancestatus,
      loadVehicletype,
      loadMaintenancetype,
    } = this.props;
    loadZone();
    loadMaintenancestatus();
    loadVehicletype();
    loadMaintenancetype();
  }

  render() {
    const {
      visible,
      handleCancel,
      handleSubmitSearch,
      filterObj,
      maintenancetypeLists,
      zoneLists,
      maintenancestatusLists,
      vehicletypeLists,
    } = this.props;
    return (
      <Modal
        title={i18n[this.props.language].s.search}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
      >
        <Formik
          enableReinitialize={true}
          initialValues={filterObj}
          validationSchema={yup.object().shape({})}
          onSubmit={(values, actions) => {
            handleSubmitSearch(values);
          }}
          ref={(formik) => (this.formik = formik)}
          render={({
            values,
            errors,
            status,
            touched,
            handleBlur,
            setFieldValue,
            handleSubmit,
          }) => (
            <Form onSubmit={handleSubmit}>
              {/* zone */}

              {/* <FormItem
                label={i18n[this.props.language].z.zone}
                validateStatus={touched.zone && errors.zone && "error"}
                help={touched.zone && errors.zone}
              >
                <Select
                  onChange={(value) => setFieldValue("zone", value)}
                  value={values.zone}
                >
                  <Option value="">{i18n[this.props.language].a.all}</Option>
                  {zoneLists.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </FormItem> */}

              {/* ประเภทรถ */}
              <FormItem
                label={i18n[this.props.language].v.vehicle_type}
                validateStatus={
                  touched.vehicle_type && errors.vehicle_type && "error"
                }
                help={touched.vehicle_type && errors.vehicle_type}
              >
                <Select
                  onChange={(value) => setFieldValue("vehicle_type", value)}
                  value={values.vehicle_type}
                >
                  <Option value="">{i18n[this.props.language].a.all}</Option>
                  {vehicletypeLists.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </FormItem>

              {/* ประเภทการแจ้ง */}
              <FormItem
                label={i18n[this.props.language].m.maintenance_type}
                validateStatus={touched.type && errors.type && "error"}
                help={touched.type && errors.type}
              >
                <Select
                  onChange={(value) => setFieldValue("type", value)}
                  value={values.type}
                >
                  <Option value="">{i18n[this.props.language].a.all}</Option>
                  {maintenancetypeLists.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </FormItem>

              {/* สถานะใบงาน */}
              <FormItem
                label={i18n[this.props.language].m.maintenance_status}
                validateStatus={
                  touched.maintenance_status &&
                  errors.maintenance_status &&
                  "error"
                }
                help={touched.maintenance_status && errors.maintenance_status}
              >
                <Select
                  onChange={(value) =>
                    setFieldValue("maintenance_status", value)
                  }
                  value={values.maintenance_status}
                >
                  <Option value="">{i18n[this.props.language].a.all}</Option>
                  {maintenancestatusLists.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </FormItem>

              {/* ปิดงานมาในช่วง 30 วัน */}
              <FormItem label={null}>
                <Checkbox
                  name="closed_in_30days"
                  checked={values.closed_in_30days}
                  onChange={(e) => {
                    setFieldValue("closed_in_30days", e.target.checked);
                  }}
                >
                  {i18n[this.props.language].c.closedIn30Days}
                </Checkbox>
              </FormItem>

              {/* button */}
              <Row type="flex" justify="end" style={{ marginTop: "10px" }}>
                <FormItem>
                  <Button type="primary" htmlType="submit">
                    {i18n[this.props.language].o.ok}
                  </Button>
                </FormItem>
              </Row>
            </Form>
          )}
        />
      </Modal>
    );
  }
}

export default connect(
  ({ servicerepairdevice, auth, ui: { language } }) => ({
    servicerepairdevice,
    auth,
    language,
  }),
  {}
)(FilterModal);
